module.exports = __webpack_public_path__ + "static/media/building_8.03fe0ae1.jpg";